export default "__VITE_ASSET__pWvX$wsY__"